import { motion } from 'framer-motion';
import "./WhatWeOffer.css";

export const offers = [
  {
    title: "Performance Marketing",
    tagline: "Hyper-Scale Your Growth",
    description: "Scaling your success through complex data points and high-conversion ad funnels.",
    image: "/images/performance.jpg",
    features: ["PPC Strategy", "Conversion Tracking", "Data Analytics"],
    color: "#4f46e5"
  },
  {
    title: "Influencer Marketing",
    tagline: "Humanizing Your Brand",
    description: "Humanizing your brand through strategic partnerships with expert digital creators.",
    image: "/images/Influencer Marketing.jpg",
    features: ["Creator Strategy", "Niche Outreach", "Campaign Mgmt"],
    color: "#ec4899"
  },
  {
    title: "Celebrity & Influencer Marketing",
    tagline: "Iconic Market Presence",
    description: "Elevating your market presence through high-impact iconic partnerships.",
    image: "/images/celebrity-marketing.jpg",
    features: ["Brand Ambassadorship", "PR Integration", "Global Reach"],
    color: "#f59e0b"
  },
  {
    title: "Social Media Management",
    tagline: "Community-First Growth",
    description: "Building vibrant, reacting communities across every social platform landscape.",
    image: "/images/social media management.jpg",
    features: ["Content Calendar", "Community Growth", "Platform Strategy"],
    color: "#0ea5e9"
  },
  {
    title: "SEO Mastery",
    tagline: "Top-Tier Organic Visibility",
    description: "Claiming the digital front page with advanced technical and semantic optimization.",
    image: "/images/SEO.jpg",
    features: ["Technical Audit", "Keyword Authority", "Link Building"],
    color: "#10b981"
  },
  {
    title: "Brand Marketing",
    tagline: "Amplify Your Essence",
    description: "Crafting legendary brand identities through emotional resonance and strategic positioning.",
    image: "/images/Branding.jpg",
    features: ["Brand Identity", "Visual Storytelling", "Positioning Strategy"],
    color: "#ef4444"
  }
];

const WhatWeOffer = ({ onServiceSelect }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <section className="what-we-offer" id="services">
      <div className="offer-container">
        <motion.div
          className="offer-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <span className="accent-tag">Expertise</span>
          <h2>What We <span className="highlight">Offer</span></h2>
          <p>We deliver bespoke digital solutions that bridge the gap between your brand and its potential.</p>
        </motion.div>

        <motion.div
          className="offer-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {offers.map((offer, index) => (
            <motion.div
              className="offer-card"
              key={index}
              variants={cardVariants}
              whileHover={{
                y: -12,
                rotateX: 2,
                rotateY: -2,
                transition: { duration: 0.4, ease: "easeOut" }
              }}
              style={{ '--accent-color': offer.color }}
              onClick={() => onServiceSelect(offer)}
            >
              <div className="card-top">
                <div className="offer-image-container">
                  <img src={offer.image} alt={offer.title} className="offer-image" />
                </div>
                <div className="card-glow"></div>
                <span className="card-tagline">{offer.tagline}</span>
              </div>
              <h3 style={{ '--accent-color': offer.color }}>{offer.title}</h3>
              <p>{offer.description}</p>
              <ul className="feature-list">
                {offer.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
